import { InboxOutlined } from '@ant-design/icons';
import { Upload, message } from 'antd';
import config from "./../../../config";
const { Dragger } = Upload;

const DraggerFileComponent = ({ id, multiple, action, token, accept, onSuccessUpload }) => {

    const props = {
        name: id,
        multiple: multiple,
        action: `${config.server}${action}`,
        headers: {
          "Authorization": `Bearer ${token}`
        },
        accept: accept,
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
                //console.log(info.file, info.fileList);
            }
            if (status === 'done') {
                message.success(`${info.file.name} archivo procesado exitosamente.`);
                onSuccessUpload(info.file);
                
            } else if (status === 'error') {
                message.error(`${info.file.name} error al cargar el archivo.`);
            }
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };

    return (
        <>
            <Dragger {...props}>
                <p className="ant-upload-drag-icon">
                <InboxOutlined />
                </p>
                <p className="ant-upload-text">Haga clic o arrastré el archivo en el área para cargarlo</p>
                <p className="ant-upload-hint">
                    El archivo debe contener un formato específico, si no será rechazado por el servidor.
                </p>
            </Dragger>
        </>
    )
}

export default DraggerFileComponent;